import { render } from "./ag-create-event-severity.vue?vue&type=template&id=19384ac8&scoped=true"
import script from "./ag-create-event-severity.vue?vue&type=script&lang=js"
export * from "./ag-create-event-severity.vue?vue&type=script&lang=js"

import "./ag-create-event-severity.vue?vue&type=style&index=0&id=19384ac8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19384ac8"]])

export default __exports__